import React, {useEffect, useState, Fragment, useRef} from 'react';
import {connect} from "react-redux";
//import GLBViewer from "./GLBViewer";
import LightIntensitySlider from "./workspaceComponents/LightIntensitySlider";
import LightingSwitch from "./workspaceComponents/LightingSwitch";
import SqftStore from "../../canvas/store/sqftStore";
import ExportButton from "./workspaceComponents/ExportButton";
import config from "../../canvas/store/sqftConfig";
import sqftConfig from "../../canvas/store/sqftConfig";
import {SQFT_AR3D_GLB_VIEWER} from "../../../constants";
import SingleModelGLBViewer from "./glbViewer/SingleModelGLBViewer";
import ScreenshotButton from "./workspaceComponents/ScreenshotButton";
// import ToggleDoorsButton from "./workspaceComponents/ToggleDoorsButton";
import store from "../../../../../store";
import {setMultiLoader} from "../../../../../actions/actionFunctions";
import {loadScriptPromise} from "../../../../../misc/loadScript";
import {ASYNC_SCRIPTS} from "../../../../../loadingLogic";
import useDebugOverlay from "./useDebugOverlay";
import BackgroundColorPicker from "./workspaceComponents/BackgroundColorPicker";
import PhotoViewButton from "./workspaceComponents/PhotoViewButton";
import QualityModeButton from "./workspaceComponents/QualityModeButton";
//import {getSeparateModelsViewer} from "./3dViewer/SeparateModelsViewer";
import ThreeScene from "./glbViewer/ThreeScene";
// import ChangeColorButton from "./workspaceComponents/ChangeColorButton";
import {addShadowsForAllModels} from "../../../helpers/sqft3dArSceneHelper";
import workspaceControllers from "../../canvas/store/workspaceControllers";
// import ThreeScene from "./glbViewer/ThreeSceneV2";
//import SeparateModelGLBViewerV2 from "./glbViewer/SeparateModelGLBViewerV2";
//import GLBViewerModels from "./GLBViewerModels";

const ShapesThreeJsViewer = (props) => {
  const {cabinetsGlb, isMobile} = props;
  const {SQFTViewMode} = props;
  const canvasRef = useRef(null); // Changed to useRef for consistency
  const viewGLRef = useRef(null); // Use a ref to persist the GLBViewer instance
  const lightIntensity = 20;
  const minLightningValue = 0;
  const maxLightningValue = 140;
  useDebugOverlay(false);
  //const [bgColor, setBgColor] = useState("#cccccc");
  const [bgColor, setBgColor] = useState("#D8D8D8");
  const [enhanced3DQuality, setEnhanced3DQuality] = useState(false);

  // Handler for background color change
  const handleBackgroundColorChange = (color) => {
    // color.hex contains the new hex color
    setBgColor(color.hex);
    // If viewer is instantiated and has the method, call it to update background
    if (viewGLRef.current && typeof viewGLRef.current.setBackgroundColor === "function") {
      viewGLRef.current.setBackgroundColor(color.hex);
    }
  };

  useEffect(() => {
    let resizeAnimationFrameId = null;
    let canvasResizeObserver = null;
    let isInitializationActive = true;

    // ******************* EVENT LISTENERS ******************* //
    // const onMouseMove = (event) => {
    //   viewGL.onMouseMove(event);
    // }
    // const onMouseDown = (event) => {
    //   viewGL.onMouseDown(event);
    // }
    // const onMouseUp = (event) => {
    //   viewGL.onMouseUp(event);
    // }
    // const onWheel = (event) => {
    //   viewGL.onWheel(event);
    // }
    const resizeViewerToWorkspace = () => {
      resizeAnimationFrameId = null;
      const canvas = canvasRef.current;
      const viewer = viewGLRef.current;

      if (!canvas || !viewer || typeof viewer.onWindowResize !== 'function') {
        return;
      }

      // The workspace includes footer padding; the responsive canvas is the
      // actual WebGL viewport whose dimensions camera/renderer must match.
      viewer.onWindowResize(canvas.clientWidth, canvas.clientHeight);
    };

    const scheduleViewerResize = () => {
      if (resizeAnimationFrameId !== null) {
        return;
      }

      resizeAnimationFrameId = window.requestAnimationFrame(resizeViewerToWorkspace);
    };

    const cleanup = (viewerToDispose = viewGLRef.current) => {
      if (canvasResizeObserver) {
        canvasResizeObserver.disconnect();
        canvasResizeObserver = null;
      }
      if (resizeAnimationFrameId !== null) {
        window.cancelAnimationFrame(resizeAnimationFrameId);
        resizeAnimationFrameId = null;
      }
      if (
        viewerToDispose
        && viewerToDispose.stopAnimation
        && (viewerToDispose.scene || viewerToDispose.renderer || viewerToDispose.controls)
      ) {
        viewerToDispose.stopAnimation();
        viewerToDispose.dispose();
      }
      if (viewGLRef.current === viewerToDispose) {
        viewGLRef.current = null;
      }
      if (SqftStore.viewGL === viewerToDispose) {
        SqftStore.viewGL = null;
      }
      if (window.gc) {
        window.gc();
      }
      window.removeEventListener('resize', scheduleViewerResize);
    };

    const connectViewerToWorkspace = (viewer) => {
      viewGLRef.current = viewer;
      SqftStore.viewGL = viewer;

      if (canvasRef.current && typeof ResizeObserver === 'function') {
        canvasResizeObserver = new ResizeObserver(scheduleViewerResize);
        canvasResizeObserver.observe(canvasRef.current);
      }

      window.addEventListener('resize', scheduleViewerResize);
      scheduleViewerResize();
    };

    const initializeViewer = async () => {
      await loadScriptPromise(ASYNC_SCRIPTS.three, "three");

      if (!isInitializationActive || !canvasRef.current) {
        return;
      }

      store.dispatch(setMultiLoader({ activeStep: 0, visible: true, finished: false }));

      cleanup();

      let threeScene;
      const isCurrentViewer = () => (
        isInitializationActive && viewGLRef.current === threeScene
      );

      try {
        switch (sqftConfig.threeD.glbViewer) {
          case SQFT_AR3D_GLB_VIEWER.singleModel:
            //this viewer will load models using Vlad's api:
            threeScene = new SingleModelGLBViewer(canvasRef.current, cabinetsGlb, lightIntensity, isMobile);
            connectViewerToWorkspace(threeScene);
            break;
          case SQFT_AR3D_GLB_VIEWER.separateModels:
          default:
            //this viewer will load models separately (see also setCabinetGLBFromCabinetsSet):
            threeScene = new ThreeScene(canvasRef.current, lightIntensity, isMobile, { enhanced3DQuality });
            threeScene.setBackgroundColor(bgColor);
            threeScene.startAnimation();
            connectViewerToWorkspace(threeScene);

            await threeScene.modelsLoader.loadAllModels(isCurrentViewer);
            if (!isCurrentViewer()) {
              return;
            }

            addShadowsForAllModels(threeScene.scene);
            threeScene.refreshCabinetLighting();

            //V1 scene
            threeScene.calculateAndSetCameraPosition(threeScene.modelsLoader.modelsCenter, threeScene.modelsLoader.modelsSize);
            //threeScene.lighting.updateSceneLighting('addLightV10', threeScene.modelsLoader.modelsCenter);

            //V2 scene
            //threeScene.addDefaultLights(threeScene.modelsLoader.modelsCenter, threeScene.modelsLoader.modelsSize);

            threeScene.closeMultiLoader();
        }
      } catch (e) {
        if (!isInitializationActive || viewGLRef.current !== threeScene) {
          return;
        }

        console.error('[3D viewer] initialization error:', e);
        if (threeScene && typeof threeScene.closeMultiLoader === 'function') {
          threeScene.closeMultiLoader();
        } else {
          store.dispatch(setMultiLoader({ activeStep: 0, visible: false, finished: true }));
        }
      }

      // ******************* INIT LISTENERS *******************
      // canvas.addEventListener('mousemove', onMouseMove);
      // canvas.addEventListener('mousedown', onMouseDown);
      // canvas.addEventListener('mouseup', onMouseUp);
      // canvas.addEventListener('wheel', onWheel);
    };

    initializeViewer();

    return async () => {
      isInitializationActive = false;
      const viewGL = SqftStore.viewGL;
      if (viewGL && viewGL.renderer) {
        const canvas = viewGL.renderer.domElement;

        // Ensure rendering has completed at least once
        await new Promise((resolve) => requestAnimationFrame(resolve));
        await canvas.toBlob((blob) => {
          workspaceControllers.images3dAutoSaved.removeAllResources();
          workspaceControllers.images3dAutoSaved.saveBlobAsScreenshot(blob);
        }, 'image/png');
      } else {
        console.error('Renderer instance not found');
      }

      cleanup(viewGL);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canvasRef, cabinetsGlb, SQFTViewMode, enhanced3DQuality]);

  return (
    <Fragment>
      <div className={"threeDWorkspace-tools"}>
        { config.isDevMode() ? <LightIntensitySlider
            intensityValue={lightIntensity}
            minValue={minLightningValue}
            maxValue={maxLightningValue} />
          : "" }
        { config.isDevMode() ? <ExportButton/> : "" }
        { config.isDevMode() ? <LightingSwitch viewGLRef={viewGLRef} /> : "" }
        <QualityModeButton
          enhanced3DQuality={enhanced3DQuality}
          onToggle={() => setEnhanced3DQuality(!enhanced3DQuality)}
        />
        {/*<ToggleDoorsButton />*/}
        <PhotoViewButton />
        <ScreenshotButton />
        <BackgroundColorPicker color={bgColor}
                               onChange={handleBackgroundColorChange} />
        {/*<ChangeColorButton />*/}
      </div>
      <canvas className="threeDWorkspace-canvas" ref={canvasRef} />
    </Fragment>
  );
}

const mapStateToProps = (store) => ({
  cabinetsGlb: store.sqftState.cabinetsGlb,
  isMobile: store.serverState.isMobile,
  SQFTViewMode: store.sqftState.SQFTViewMode,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ShapesThreeJsViewer);
